import React from 'react';
import NewProductUpload from './NewProductUpload';

const ProductUpload = () => {
	return (
		<>
			<div className=' flex flex-col-reverse md:flex-row items-start justify-center lg:pt-24 pt-10 mb-36 lg:gap-24  lg:px-36 px-9'>
				<div className=' w-full lg:w-[75%] '>
					<p className='font-semibold md:text-2xl sm:text-xl text-lg mb-1'>Add New Article</p>

					<div className=' border-[1px] border-black sm:mb-8 mb-6 sm:w-12 w-10 ' />

					<NewProductUpload />
				</div>
			</div>
		</>
	);
};

export default ProductUpload;
